import { PORTAL_ROUTE } from '../../../../constants/routes';
import config from '../../../../utils/config';

export const WDAC_PACKAGED_APP_PREVIOUS_PATH = 'wdacPackagedAppPreviousPath';

export const wdacPackagedAppTabs = (packagedAppId, counts) => [
  {
    label: `General`,
    value: `${PORTAL_ROUTE}/packaged-details/${packagedAppId}/general`,
  },
  {
    label: `Impacted Devices (${counts || 0})`,
    value: `${PORTAL_ROUTE}/packaged-details/${packagedAppId}/impacted-devices`,
  },
];

// The top header row. Spans have to add up to PACKAGED_APPS_COLUMNS, and the column each group ends
// on carries groupEnd so the divider runs down the body as well as across the headings.
export const PACKAGED_APPS_COLUMN_GROUPS = [
  { title: '', span: 1 },
  { title: 'Packaged app details', span: 2 },
  { title: 'Affected Devices', span: 3 },
  { title: 'Launch attempts', span: 3 },
];

export const PACKAGED_APPS_COLUMNS = [
  { key: 'status', label: 'Status', sortable: true, sortKey: 'status', groupEnd: true },
  {
    key: 'displayName',
    label: 'Display Name',
    sortable: true,
    sortKey: 'displayName',
    tooltip: 'Package family name is shown underneath the display name.',
  },
  {
    key: 'signatureKind',
    label: 'Signature Kind',
    sortable: true,
    sortKey: 'signatureKind',
    groupEnd: true,
  },
  { key: 'affectedDevices5Days', label: '5 Days', sortable: true, sortKey: 'affectedDevices5Days' },
  {
    key: 'affectedDevices30Days',
    label: '30 Days',
    sortable: true,
    sortKey: 'affectedDevices30Days',
  },
  {
    key: 'affectedDevices90Days',
    label: '90 Days',
    sortable: true,
    sortKey: 'affectedDevices90Days',
    groupEnd: true,
  },
  { key: 'launchAttempts5Days', label: '5 Days', sortable: true, sortKey: 'launchAttempts5Days' },
  {
    key: 'launchAttempts30Days',
    label: '30 Days',
    sortable: true,
    sortKey: 'launchAttempts30Days',
  },
  {
    key: 'launchAttempts90Days',
    label: '90 Days',
    sortable: true,
    sortKey: 'launchAttempts90Days',
  },
];

export const trustedStatus = 'Trusted';

export const packagedAppsStatusList = [
  {
    id: 'Unknown',
    label: 'No Status',
    value: 'Unknown',
    name: 'No Status',
  },
  {
    id: 'Trusted',
    label: 'Trusted',
    value: 'Trusted',
    name: 'Trusted',
  },
  {
    id: 'Untrusted',
    label: 'Untrusted',
    value: 'Untrusted',
    name: 'Untrusted',
  },
];

export const PACKAGED_APPS_STATUS_OPTIONS = packagedAppsStatusList.map(({ value, label }) => ({
  value,
  label,
}));

export const PACKAGED_APPS_STATUS_CATALOG_TARGET = 'your packaged apps supplemental policy';

export const EDIT_STATUS_NOTE_INFO_LINK = `${config.knowledgeBaseUrl}faq/wdac-results/#what-effect-does-marking-a-packaged-app-as-trusted-or-untrusted-have`;
export const INITIAL_MASK = '________-____-____-____-____________';
